import { Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonModule } from 'primeng/skeleton';

export type SkeletonVariant =
  | 'card'
  | 'detail-header'
  | 'detail-body'
  | 'list-items'
  | 'table';

@Component({
  selector: 'app-skeleton',
  standalone: true,
  imports: [CommonModule, SkeletonModule],
  templateUrl: './skeleton.component.html',
  styleUrl: './skeleton.component.scss',
})
export class SkeletonComponent {
  readonly variant = input.required<SkeletonVariant>();
  /** Repeats list rows for `list-items` only (minimum 1). */
  readonly count = input(3);

  readonly listRepeatIndices = computed(() =>
    Array.from({ length: Math.max(1, this.count()) }, (_, i) => i),
  );
}
